<iframe 
  title="base-iframe"
  allow="autoplay; encrypted-media"
  allowfullscreen
  frameborder="0"
  [src]="safeSrc">
</iframe>

